
$(document).ready(function($) {
  objectFitVideos();
});
